var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"fs-32 lh-16 hover-primary",class:`nexd-icon-32-${_vm.value ? 'seen' : 'unseen'}`,attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }